import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c5cdc20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "shipping-address-form" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, " Add New Shipping Address ", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Save ")

import { reactive, onMounted } from 'vue';
  import _ from 'lodash';
  import { ColorVariants } from '@/constants';
  import { CheckoutStore } from '@/stores';
  import getInitAddress, { IAddress } from '@/types/address';
  import { useRouter, useRoute } from 'vue-router';
  import { FormItem } from '@/types/form';

  // TODO: 接口要调整

  interface IProps {
    store: CheckoutStore
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    store: null
  },
  setup(__props: any) {

const props = __props as {
    store: CheckoutStore
  }

  
  const route = useRoute();
  const router = useRouter();
  const form = reactive<IAddress>(getInitAddress());
  const id = Number(route.params.id) || 0;

  const formItems: FormItem[] = [
    {
      key: 'first_name',
      label: 'First Name',
      name: 'first_name',
      type: 'input',
      placeholder: 'First Name',
      required: true
    },
    {
      key: 'last_name',
      label: 'Last Name',
      name: 'last_name',
      type: 'input',
      placeholder: 'Last Name',
      required: true
    },
    {
      key: 'phone_number',
      label: 'Phone Number',
      name: 'phone_number',
      type: 'input',
      placeholder: 'Phone Number',
      required: true
    },
    {
      key: 'postal_code',
      label: 'Postal Code',
      name: 'postal_code',
      type: 'input',
      placeholder: 'Postal Code',
      required: true
    },
    {
      key: 'country_id',
      label: 'Country',
      name: 'country_id',
      type: 'select',
      placeholder: 'Country',
      required: true,
       options: [
        {
          text: '1',
          value: 1
        },
      ]
    },
    {
      key: 'province_id',
      label: 'Province',
      name: 'province_id',
      type: 'select',
      placeholder: 'Province',
      required: true,
      options: [
        {
          text: '1',
          value: 1
        },
      ]
    },
    {
      key: 'city',
      label: 'City',
      name: 'city',
      type: 'input',
      placeholder: 'City',
      required: true
    },
    {
      key: 'address1',
      label: 'Address 1',
      name: 'address1',
      type: 'input',
      placeholder: 'Address 1',
      required: true
    },
    {
      key: 'address2',
      label: 'Address 2',
      name: 'address2',
      type: 'input',
      placeholder: 'Address 2',
      required: false
    },
    {
      key: 'company',
      label: 'Company',
      name: 'company',
      type: 'input',
      placeholder: 'Company',
      required: false
    },
    {
      key: 'is_default',
      label: 'Default Address',
      name: 'is_default',
      type: 'checkbox',
      placeholder: 'Default Address',
      required: false,
      options: [
        {
          text: 'Yes',
          value: true
        },
        {
          text: 'No',
          value: false
        }
      ]
    }
  ];

  function handleFormItemChange(data: any) {
    _.set(form, data.key, data.value);
  }

  async function handleSubmit() {
    if (id) {
      await props.store.updateAddress(form);
    } else {
      props.store.saveNewAddress(JSON.parse(JSON.stringify(form)));
    }
    router.go(-1);
  }

  onMounted(async () => {
    Object.assign(form, props.store.getAddressById(id));
  });


return (_ctx: any,_cache: any) => {
  const _component_AppFormGroupItem = _resolveComponent("AppFormGroupItem")!
  const _component_AppLoadingButton = _resolveComponent("AppLoadingButton")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_b_form, {
        onSubmit: _withModifiers(handleSubmit, ["stop","prevent"])
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(formItems, (item, index) => {
            return _createVNode(_component_AppFormGroupItem, {
              key: index,
              form: _unref(form),
              config: item,
              onChange: handleFormItemChange
            }, null, 8, ["form", "config"])
          }), 64)),
          _createVNode(_component_AppLoadingButton, {
            class: "btn-submit",
            variant: _unref(ColorVariants).primary,
            pill: "",
            type: "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["variant"])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ])
  ]))
}
}

})